export function parseRTCondCookie(cookie: string) {
  const param = {};

  cookie
    .replace(/"/g, '')
    .split('|')
    .forEach((str) => {
      const [name, val] = str.split('=');

      if (!name) return;
      if (!param[name]) param[name] = [];
      param[name].push(val);
    });

  return param;
}
